<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">

                    <v-app>
                        <v-container fluid>
                            <v-card elevation="2" outlined>
                                <v-card-title >
<!--                                    v-if="$can('transaction_create')"-->
                                    <v-btn  to="/permission/create" rounded color="#308BB0" class="text-white">
                                        <v-icon>mdi-plus</v-icon>
                                        افزودن دسته بندی
                                    </v-btn>
                                    <v-spacer/>
                                    مدیریت سطح دسترسی
                                    <v-spacer/>
                                    <v-btn :loading="loading" @click="this.fetchIndexData" color="primary" rounded class="text-white">
                                        <v-icon>mdi-refresh</v-icon>
                                       به روزرسانی
                                    </v-btn>

                                </v-card-title>

                                <v-divider/>

                                <v-card-title>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-12">

                                                <!--Main DataTable Part-->
                                                <datatable
                                                    :columns="columns"
                                                    :data="data"
                                                    :total="total"
                                                    :query="query"
                                                    :xprops="xprops"
                                                    :HeaderSettings="false"
                                                    :pageSizeOptions="[10, 25, 50, 100]"
                                                >
                                                    <global-search :query="query" class="pull-right"/>
                                                </datatable>




                                            </div>
                                        </div>
                                    </div>



                                </v-card-title>

                            </v-card>


                        </v-container>




                    </v-app>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import DatatableActions from "../../content/Datatables/DatatableActions";
import GlobalSearch from "../../content/Datatables/GlobalSearch";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
    components: {
        GlobalSearch,
    },
    data() {
        return {
            editor: {
                editor: ClassicEditor,
                editorConfig: {
                    // extraPlugins: [CKEditorUploadAdapterPlugin],
                }
            },
            content:'',
            columns: [
                {
                    title: 'شناسه',
                    field: 'id',
                    sortable: true,
                    colStyle: 'width: 100px;'
                },
                {
                    title: 'نام فارسی',
                    field: 'name_fa',
                    sortable: true,
                },
                {
                    title: 'عنوان',
                    field: 'name',
                    sortable: true
                },
                {
                    title: 'وضعیت',
                    field: 'type',
                    sortable: true
                },
                {
                    title: 'عملیات',
                    tdComp: DatatableActions,
                    visible: true,
                    thClass: 'text-center',
                    tdClass: 'text-right td-actions',
                    colStyle: 'width: 150px;'
                }
            ],
            query: {sort: 'id', order: 'desc', limit: 100, s: ''},
            xprops: {
                module: 'PermissionsIndex',
                route: 'permission',
                permission_prefix: 'permission_',

            }
        }
    },
    beforeDestroy() {
        this.resetState()
    },
    computed: {
        ...mapGetters(["layoutConfig"]),
        ...mapGetters('PermissionsIndex', ['data', 'total', 'loading']),

        config() {
            return this.layoutConfig();
        }
    },
    watch: {
        query: {
            handler(query) {
                this.setQuery(query)
                this.fetchIndexData()
            },
            deep: true
        }
    },
    methods: {
        ...mapActions('PermissionsIndex', [
            'fetchIndexData',
            'setQuery',
            'resetState'
        ])
    }
}
</script>
